import React from 'react';
import { Nav } from 'react-bootstrap';
import { NavLink } from 'react-router-dom';
 
const Sidebar = () => {
  return (
      
        <Nav defaultActiveKey="/" className="flex-column">
        
          <NavLink to="/dashboard" className="text-white nav_menu_item">
            {/* <img src="Dashboard.png"/> */}
            Dashboard
            </NavLink>
          <NavLink to="/document-list" className="text-white nav_menu_item">Documents</NavLink>
          {/* <NavLink to="/data-mapping" className="text-white nav_menu_item">Data Mapping</NavLink> */}
        </Nav>
  );
};
 
export default Sidebar;